/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import CodeEditor from "./CodeEditor";

export default class CodeEditorModal extends BaseCom {
    render() {
        return this.wrapModal(<CodeEditor code={this.props.code} onChange={this.props.onChange} />, 'Editor', 'xl');
    }
}